import { render } from "./RiAdd.vue?vue&type=template&id=417d2f64"
import script from "./RiAdd.vue?vue&type=script&lang=js"
export * from "./RiAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "417d2f64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('417d2f64', __exports__)) {
    api.reload('417d2f64', __exports__)
  }
  
  module.hot.accept("./RiAdd.vue?vue&type=template&id=417d2f64", () => {
    api.rerender('417d2f64', render)
  })

}


export default __exports__